function getUrlParam (name) {
  let url = window.location.href
  let start = url.indexOf('?')
  if (start > -1) {
    url = url.substring(start + 1)
  }

  let parameter = {}
  if (url) {
    let queryParams = url.split('&')
    queryParams.forEach(
      (item) => {
        let param = item.split('=')
        parameter[param[0]] = decodeURIComponent(param[1]) || ''
      }
    )
  }

  if (name) {
    if (parameter.hasOwnProperty(name)) {
      return parameter[name]
    } else {
      return null
    }
  }

  return parameter
}

function combParamByJson (obj) {
  let param = ''
  for (let key in obj) {
    let opt = '&'
    if (param === '') {
      opt = '?'
    }
    param += opt + key + '=' + encodeURIComponent(obj[key])
  }

  return param
}

export default { getUrlParam, combParamByJson }



// WEBPACK FOOTER //
// ./src/util/urltool.js